

export function reorderArrayItem<T>(array: T[], sourceIndex: number, destinationIndex: number): T[] {
  const newArray = [...array];
  const [reorderedItem] = newArray.splice(sourceIndex, 1);
  newArray.splice(destinationIndex, 0, reorderedItem);
  return newArray;
}